import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AppConfigService } from './app-config.service';
import { ErrorHandlerService } from './error-handler.service';
import { ProductionJobDoc } from '../models/review/production-job-doc.model';

@Injectable({
  providedIn: 'root'
})
export class ProductionJobDocsService {

  constructor(private http: HttpClient, private errorHandler: ErrorHandlerService, private appConfigService: AppConfigService) { }

  getProductionJobDocs(docId: string, productionId: string): Observable<ProductionJobDoc> {
    return this.http.get<ProductionJobDoc>(`${this.appConfigService.getConfig().webApi}/api2/productionJobs/${productionId}/docs/${docId}`)
      .pipe(catchError(this.errorHandler.handleError<ProductionJobDoc>(`get production job docs`)));
  }

  getDocCountsByProductionJobId(productionJobId: string): Observable<any> {
    return this.http.get(`${this.appConfigService.getConfig().webApi}/api2/ProductionJobs/${productionJobId}/docs/count`)
      .pipe(catchError(this.errorHandler.handleError<any>(`get Doc counts in productionJobId=${productionJobId}`)));
  }
}
